import { DataGridPro } from "@mui/x-data-grid-pro";
import { useEffect, useState } from "react";
import { useContext } from "react";
import { DeleteOutline } from "@material-ui/icons";
import GeneralContext from "../../context/GeneralContext/GeneralContext";
import api from "../../services/api";
import SL_Button from "../../components/buttons/Button";
import { displayMessage } from "../../services/helper";
import patient_protocol_grid_columns from "./grid_columns/patient_protocol_grid_columns";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import ListPatientExerciseProtocolModal from "../../components/modals/ListPatientProtocolModal";
import AddPatientProtocolModal from "../../components/modals/AddPatientProtocolModal";
import ProtocolDetailsModal from "../../components/modals/ProtocolDetailsModal";
import { FooterTable } from "../../components/grid/FooterTable";
import { Popconfirm } from "antd";

const ListPatientProtocol = () => {
  const rowsPerPage = 20;
  const initialOffset = 0;
  const [offset, setOffset] = useState(initialOffset);
  const [quantityRows, setQuantityRows] = useState(rowsPerPage);
  const [patientProtocol, setPatientProtocol] = useState([]);
  const [isListExerciseModalOpen, setIsListExerciseModalOpen] = useState(false);
  const [isAddProtocolModalOpen, setIsAddProtocolModalOpen] = useState(false);
  const [isProtocolDetailsModalOpen, setIsProtocolDetailsModalOpen] =
    useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const location = useLocation();
  const { patientId } = location.state;
  const navigate = useNavigate();
  const { setShowLoading, windowHeight, mobile_mode } =
    useContext(GeneralContext);
  const DataGridProHeight = windowHeight * 0.7;
  const handleListExerciseModal = () => {
    setIsListExerciseModalOpen(true);
  };
  const handleAddProtocolModal = () => {
    setIsAddProtocolModalOpen(true);
  };
  const handleProtocolDetailsModal = () => {
    setIsProtocolDetailsModalOpen(true);
  };

  const loadPatientProtocols = async (currentOffset = offset) => {
    setShowLoading(true);
    try {
      const { data } = await api.patient_protocol.getProtocolsByPatient({
        patientId: patientId.id,
        currentOffset,
        limit: rowsPerPage,
      });
      
      setQuantityRows(data.count);
      
      setPatientProtocol(data.rows);
      
    } catch (error) {
      console.log(error);
    } finally {
      setShowLoading(false);
    }
  };

  const handleRowClick = (params) => {
    setSelectedRow(params.row);
  };

  const handleOnDelete = async (body) => {
    setShowLoading(true);
    try {
      await api.patient_protocol.deletePatientProtocol(body)
      alert(displayMessage("DELETE_PROTOCOL_SUCCESS"), "success");
    } catch (error) {
      console.log(error);
    } finally {
      setShowLoading(false);
    }
  };

  const customGrids = [
    {
      field: "exercises",
      width: 400,
      headerName: displayMessage("LIST_EXERCISES"),
      renderCell: (params) => {
        return (
          <SL_Button onClick={handleListExerciseModal}>
            {displayMessage("LIST")}
          </SL_Button>
        );
      },
    },
    {
      field: "exclude",
      headerName: displayMessage("EXCLUDE_PROTOCOL"),
      width: 350,
      renderCell: (params) => {
        return (
          <div>
            <Popconfirm
              zIndex={10001}
              placement="bottomLeft"
              title={displayMessage("WARNING_REMOVE_EXERCISE")}
              onConfirm={() => {
                handleOnDelete({
                  protocolId: params.row.protocolId,
                  patientId: patientId.id,
                });
                setPatientProtocol(prev =>
                  prev.filter(protocol => protocol.id !== params.row.id)
                );
                setSelectedRow(null)
              }}
              okText={displayMessage("YES")}
              cancelText={displayMessage("NO")}
            >
              <SL_Button
                style={{
                  background: "red",
                  borderColor: "pink",
                  color: "pink",
                  fontWeight: "bold",
                }}
                shape="circle"
                icon={<DeleteOutline />}
              ></SL_Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    !patientId ? navigate("/") : loadPatientProtocols();
  }, [patientId, navigate]);

  return (
    <>
      {isListExerciseModalOpen && (
        <ListPatientExerciseProtocolModal
          isPatientProtocolModalOpen={isListExerciseModalOpen}
          setIsPatientProtocolModalOpen={setIsListExerciseModalOpen}
          selectedRow={selectedRow}
        />
      )}
      {isAddProtocolModalOpen && (
        <AddPatientProtocolModal
          isPatientProtocolModalOpen={isAddProtocolModalOpen}
          setIsPatientProtocolModalOpen={setIsAddProtocolModalOpen}
          loadPatientProtocols={() => loadPatientProtocols()}
          selectedRow={selectedRow}
          patientId={patientId}
        />
      )}
      {isProtocolDetailsModalOpen && (
        <ProtocolDetailsModal
        setSelectedRow={setSelectedRow}
        refreshProtocolExercises={()=>loadPatientProtocols()}
          isPatientProtocolModalOpen={isProtocolDetailsModalOpen}
          setIsPatientProtocolModalOpen={setIsProtocolDetailsModalOpen}
          selectedRow={selectedRow}
          patientId={patientId}
        />
      )}
      <div className="flex flex-col w-full">
        <div style={{ height: DataGridProHeight, minHeight: 300 }}>
          <div
            className={`flex flex-1 justify-between p-2 bg-appian-blue gap-1 ${
              mobile_mode ? `flex-col` : `flex-row`
            } `}
          >
            <span className="self-center text-white flex-1 text-center font-medium">
              {displayMessage("PROTOCOLS_PATIENT_LIST")}: {patientId?.full_name}
            </span>
            <div
              className={`flex gap-1 ${mobile_mode ? `flex-col` : `flex-row`}`}
            >
              {selectedRow !== null && (
                <SL_Button
                  onClick={handleProtocolDetailsModal}
                  type="default"
                  className="items-center w-30 flex"
                >
                  {displayMessage("PROTOCOL_DETAILS")}
                </SL_Button>
              )}
              <SL_Button
                onClick={handleAddProtocolModal}
                type="default"
                className="items-center w-30 flex"
              >
                {displayMessage("ADD_PROTOCOLS")}
              </SL_Button>
            </div>
          </div>
          <DataGridPro
            onRowClick={handleRowClick}
            columns={patient_protocol_grid_columns.concat(customGrids)}
            rows={patientProtocol}
            components={{
              Footer: () => (
                <>
                  <FooterTable
                    offset={offset}
                    rowsPerPage={rowsPerPage}
                    quantityRows={quantityRows}
                    setOffset={setOffset}
                    functionOnChange={loadPatientProtocols}
                  />
                </>
              ),
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ListPatientProtocol;
